<script setup lang="ts">

const user = useAuthStore()
const route = useRoute();
const isShowBooking = ref<boolean>(false)
const isShowPayg = ref<boolean>(false)
const booking_menu = ref<HTMLElement>()
const pgym_menu = ref<HTMLElement>()

onMounted(  ()=>{
    window.addEventListener('click', closeDropDown);
})
onUnmounted(()=> {
    window.removeEventListener('click', closeDropDown);
})

function closeDropDown(event:MouseEvent): void{

    if(booking_menu.value){
        if(!booking_menu.value.contains(event.target as HTMLElement) ){
            isShowBooking.value = false
        }
    }
    if(pgym_menu.value){
        if(!pgym_menu.value.contains(event.target as HTMLElement) ){
            isShowPayg.value = false
        }
    }

}
function  clickBooking(): void {
      isShowBooking.value = !isShowBooking.value
}
function clickPayg(): void{
    isShowPayg.value = !isShowPayg.value

}
function clickMypage()  {
    window.location.href = "/user/mypage"
}
function clickQr() {
    window.location.href = '/user/qr'
}
function gotoPayg(tenant_code:string){
    window.location.href = `/user/mypage/tenant/${tenant_code}/payg`
}
function clickReservation(){
    window.location.href = '/user/reservation'
}
function gotoBooking(tenant_code:string){
    window.location.href = `/user/mypage/tenant/${tenant_code}/booking`
}
</script>
<template>
    <!-- PC トップメニュー -->
    <div class="navbar is-fixed-top pc-header hide_pc_global_menu" >
        <div class="columns is-vcentered is-mobile" :style="{ width: '100%' }">
            <div class="column is-2-desktop is-10-touch">
                <nuxt-link to="/user/mypage">
                    <img src="~/assets/img/core-space-logo.png" class="core-space-logo m-3" />
                </nuxt-link>
            </div>
            <div class="column is-hidden-touch">
                <nav>
                    <div class="navbar-menu columns is-centered is-vcentered is-active">
                        <nuxt-link
                            class="navbar-item column is-narrow mx-2"
                            @click="clickQr()">

                            <span class="icon is-large has-text-centered mb-1">
                                <ion-icon-qr-code-outline/>
                            </span>
                            <span class="is-large">QR</span>
                        </nuxt-link>
                        <!-- 予約 -->
                        <div class="navbar-item column is-narrow mx-2" style="cursor: pointer">
                            <div class="dropdown is-hoverable">
                                <div class="dropdown-trigger">
                                    <span class="icon is-large has-text-centered mb-1">
                                        <ion-icon-calendar-outline />
                                    </span>
                                    <span class="is-large">予約</span>
                                </div>
                                <div class="dropdown-menu" role="menu">
                                    <div class="dropdown-content">
                                        <div v-for="contract in user.contracts" :key="contract.id"
                                            class="dropdown-item navbar-item">
                                            <nuxt-link v-if="contract.has_rsv_service_master && !contract.suspended"  @click="gotoBooking(contract.tenant_code)">
                                                {{ contract.tenant_name }}
                                            </nuxt-link>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <!-- 予約  -->
                        <nuxt-link class="navbar-item column is-narrow mx-2"  @click="clickReservation()">
                            <span class="icon is-large has-text-centered mb-1">
                                <ion-icon-list-outline />

                            </span>
                            <span class="is-large">予約一覧</span>
                        </nuxt-link>
                        <!-- 時間利用 -->
                        <div  class="navbar-item column is-narrow mx-2" style="cursor: pointer">
                            <div class="dropdown is-hoverable" >
                                <div class="dropdown-trigger">
                                    <span class="icon is-large has-text-centered mb-1">
                                        <ion-icon-drop-in/>
                                    </span>
                                    <span class="is-large">時間利用</span>
                                </div>
                                <div class="dropdown-menu" role="menu">
                                    <div class="dropdown-content">
                                        <div v-for="contract in user.contracts" :key="contract.id"
                                            class="dropdown-item navbar-item">
                                            <nuxt-link v-if="contract.has_payg_service_master && !contract.suspended"  @click="gotoPayg(contract.tenant_code)">
                                                {{ contract.tenant_name }}
                                            </nuxt-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 時間利用  -->
                        <nuxt-link class="navbar-item column is-narrow mx-2" @click="clickMypage">
                            <span class="icon is-large has-text-centered mb-1">
                                <ion-icon-person-circle-outline />
                            </span>
                            <span class="is-large">マイページ</span>
                        </nuxt-link>
                    </div>
                    <!--  navbar fixed -->
                </nav>
            </div>
            <div class="column has-text-right is-2">
                <!-- div class="is-hidden-desktop">
            <span class="icon">
              <i
                class="fa fa-bars"
                aria-hidden="true"
                style="font-size: 1.5rem"
              />
            </span>
          </div -->
            </div>
        </div>
    </div>
    <!-- /PC トップメニュー -->
    <!-- メインコンテンツ -->
    <div id="main-area" class="container content">
        <slot name="slot-contents" />
    </div>
    <!-- /メインコンテンツ -->
    <!-- モバイル時グローバルメニュー -->
    <div
      class="navbar is-fixed-bottom"
      :style="{ height: 'max-content', border: 'none' }"
    >
    <nav
        class="is-hidden-desktop"
        :style="{ borderTop: '1px solid #7a7a7a' }"
      >
        <div
          class="navbar-menu is-active columns is-multiline is-mobile is-marginless"
        >
          <nuxt-link
            class="navbar-item column"
            to="/user/qr"
          >
            <span class="icon is-block has-text-centered mb-1">
              <ion-icon-qr-code-outline />
            </span>
            <span class="is-block">QR</span>
          </nuxt-link>
          <!-- 予約 -->
          <div
            class="navbar-item column dropdown is-up"
            :class="{ 'is-active': isShowBooking }"
            @click="clickBooking()"
            ref="booking_menu"
          >
            <div class="dropdown-trigger">
              <span class="icon is-block has-text-centered mb-1">
                <ion-icon-calendar-outline />
              </span>
              <span class="is-block">予約</span>
            </div>
            <div class="dropdown-menu" role="menu">
              <div class="dropdown-content">
                <div
                  v-for="contract in user.contracts"
                  :key="contract.id"
                  class="dropdown-item navbar-item"
                  style="font-size: 0.8rem"
                >
                  <nuxt-link v-if="contract.has_rsv_service_master && !contract.suspended" :to="`/user/mypage/tenant/${contract.tenant_code}/booking`"
                  >
                    {{ contract.tenant_name }}
                  </nuxt-link>
                </div>
              </div>
            </div>
          </div>
          <!-- 予約 -->
          <nuxt-link
            class="navbar-item column"
            to="/user/reservation/"
          >
            <span class="icon is-block has-text-centered mb-1">
              <ion-icon-list-outline />
            </span>
            <span class="is-block">予約一覧</span>
          </nuxt-link>
          <!-- 時間利用 -->
          <div
            class="navbar-item column dropdown is-up"
            :class="{ 'is-active':isShowPayg }"
            @click="clickPayg()"
            ref="pgym_menu"
          >
            <div class="dropdown-trigger">
              <span class="icon is-block has-text-centered mb-1">
                <ion-icon-drop-in />
              </span>
              <span class="is-block">時間利用</span>
            </div>
            <div class="dropdown-menu" role="menu">
              <div class="dropdown-content">
                <div
                  v-for="contract in user.contracts"
                  :key="contract.id"
                  class="dropdown-item navbar-item"
                  style="font-size: 0.8rem"
                >
                  <nuxt-link
                    v-if="contract.has_payg_service_master && !contract.suspended"
                    :to="`/user/mypage/tenant/${contract.tenant_code}/payg`"
                  >
                    {{ contract.tenant_name }}
                  </nuxt-link>
                </div>
              </div>
            </div>
          </div>
          <!-- 時間利用 -->
          <nuxt-link
            class="navbar-item column"
            to="/user/mypage"
          >
            <span class="icon is-block has-text-centered mb-1">
              <ion-icon-person-circle-outline />
            </span>
            <span class="is-block">マイページ</span>
          </nuxt-link>
        </div>
        <!--  navbar fixed -->
      </nav>
    </div>
     <!-- /モバイル時グローバルメニュー -->
</template>

<style lang="css">
#main-area {
  padding-top: 74px;
}

.hide_pc_global_menu {
  height: 100%;
}

.navbar.pc-header {
  height: 74px;
  border-bottom: 1px solid #7a7a7a;
  border-top: none;
}

.navbar.pc-header .core-space-logo {
  max-width: 170px;
  max-height: 80px;
}

@media only screen and (max-width: 1023px) {
  #main-area {
    padding-top: 64px;
  }
  .my-responsive-component {
    height: 0;
  }
  .navbar.pc-header {
    height: 64px;
  }
  .navbar.pc-header .core-space-logo {
    max-width: 120px;
  }
}
</style>

